import { createContext, use } from 'react';

type DiagramContextValue = {
  isAIGenerated: boolean;
  isNewDiagram: boolean;
  isSavedDiagram: boolean;
  diagramId: string | null;
  recordId: string | null;
};

export const DiagramContext = createContext<DiagramContextValue | undefined>(undefined);

// context consumer hook
export const useDiagramContext = () => {
  const context = use(DiagramContext);

  if (context === undefined) {
    throw new Error('useDiagramContext must be used within DiagramContextProvider');
  }

  return context;
};
